import type { SigmaProviderData } from '@trinity/management-app-client';
import { useChatApiClient } from '../../containers/Chat/useApiClient';
import type { SigmaTab } from './sigma-tabs';
import { SigmaDashboardViewer } from './SigmaDashboardViewer';

type Props = {
  pageId: number;
  provider: SigmaProviderData;
};

/** A Sigma page in the chat app: tab URLs are signed by chat-api, which reads the page's warehouse and schema itself. */
export const SigmaPageEmbed = ({ pageId, provider }: Props) => {
  const apiClient = useChatApiClient();

  return (
    <SigmaDashboardViewer
      config={provider}
      loadUrl={(tab: SigmaTab) => apiClient.pages.getSigmaUrl(pageId, tab)}
      cacheKey={['page', pageId]}
    />
  );
};
